import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Grid, Icon, Radio, Input } from 'semantic-ui-react';
import { connect } from 'react-redux';
import _ from 'lodash';

import * as PagingActions from 'State/paging/actions';
import * as PagingSelectors from 'State/paging/selectors';
import * as PagingConstants from 'State/paging/constants';
import {
  IngredientTable,
  withIngredientApi,
} from 'Pages/managerecipe/components/IngredientTable';

import { INITIAL_SEARCH_PARAMETERS } from '../helpers/Constants';

class IngredientListingTable extends Component {
  static propTypes = {
    setPageNumber: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    setSortColumn: PropTypes.func.isRequired,

    selected: PropTypes.object,
    onSelectIngredient: PropTypes.func,
    onSelectAllToggle: PropTypes.func,
  };

  static defaultProps = {
    select: false,
    selected: {},
    selectedAll: false,
    onSelectIngredient: () => {},
    onSelectAllToggle: () => {},
  };

  componentDidMount() {
    const { setSearchParameters } = this.props;
    setSearchParameters(INITIAL_SEARCH_PARAMETERS);
  }

  onSearchTextChange = (e) => {
    const {
      target: { value },
    } = e;
    const { searchParameters, setPageNumber, setSearchParameters } = this.props;
    const updatedSearchParameters = {
      ...searchParameters,
      Search: value,
    };
    setSearchParameters(updatedSearchParameters);
    setPageNumber(1);
  };

  setToggle = (field) => (e, data) => {
    const { searchParameters, setSearchParameters } = this.props;
    const updatedSearchParameters = {
      ...searchParameters,
      [field]: data.checked,
    };
    setSearchParameters(updatedSearchParameters);
  };

  onSelectIngredient = (ingredient) => {
    this.props.onSelectIngredient(ingredient);
  };

  onPageChange = (page) => {
    this.props.setPageNumber(page + 1);
  };

  onPageSizeChange = (pageSize, page) => {
    this.props.setPageSize(pageSize, 1);
  };

  onSortedChange = (sorted) => {
    this.props.setSortColumn(sorted);
  };

  onFilteredChange = (filtered) => {
    this.props.setFilter(filtered);
  };

  onSelectAllToggle = () => {
    const { onSelectAllToggle } = this.props;
    onSelectAllToggle();
  };

  selectIngredientCell = ({ row }) => {
    const { selected, selectedAll, total } = this.props;
    const id = _.get(row, ['_original', 'Id']);
    const ingSelected = _.get(selected, id);
    const selectedAllOneByOne = Object.keys(selected).length === total;

    return (
      <Checkbox
        label=""
        onChange={() => this.onSelectIngredient(row._original)}
        checked={ingSelected || selectedAll}
        disabled={!selectedAllOneByOne && selectedAll}
      />
    );
  };

  additionalColumns = [
    {
      id: 'SelectIngredient',
      Header: () => {
        const { selectedAll } = this.props;
        return (
          <Checkbox
            label=""
            onChange={this.onSelectAllToggle}
            checked={selectedAll}
          />
        );
      },
      Cell: this.selectIngredientCell,
      sortable: false,
      filterable: false,
      resizable: false,
      show: true,
      visibility: true,
      width: 40,
      style: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
  ];

  render() {
    const { headerTitle, modalProps, searchParameters, ...proxiedProps } =
      this.props;

    const { Search, ShowInvLinked, ShowInactive } = searchParameters;

    return (
      <Grid padded>
        <Grid.Row>
          <Grid.Column width="6" verticalAlign="middle">
            <Input
              placeholder="Smartest Lunchroom Search"
              fluid
              icon={<Icon name="search" />}
              iconPosition="left"
              onChange={this.onSearchTextChange}
              value={Search}
            />
          </Grid.Column>
          <Grid.Column width="4" verticalAlign="middle">
            <Radio
              onChange={this.setToggle('ShowInvLinked')}
              toggle
              checked={ShowInvLinked}
              label="Inventory Linked"
            />
          </Grid.Column>
          <Grid.Column width="6" verticalAlign="middle">
            <Radio
              onChange={this.setToggle('ShowInactive')}
              toggle
              checked={ShowInactive}
              label="Show Inactive / Deactivated Only"
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <IngredientTable
            {...proxiedProps}
            additionalColumns={this.additionalColumns}
            manual={true}
            controlledPaging={true}
            hasSelectAllColumn={true}
            onSortedChange={this.onSortedChange}
            onFilteredChange={this.onFilteredChange}
            onPageChange={this.onPageChange}
            onPageSizeChange={this.onPageSizeChange}
          />
        </Grid.Row>
      </Grid>
    );
  }
}
const mapState = (state) => {
  const primaryPagingSelectors = PagingSelectors.commonStatePagingSelectors(
    PagingConstants.primaryStateName
  );
  return {
    searchParameters: primaryPagingSelectors.getSearchParameters(state),
  };
};
const primaryPagingActions = PagingActions.commonStatePagingActions(
  PagingConstants.primaryPrefix
);
const mapDispatch = {
  setPageNumber: primaryPagingActions.setPageNumber,
  setPageSize: primaryPagingActions.setPageSize,
  setSortColumn: primaryPagingActions.setSortColumn,
  setFilter: primaryPagingActions.setFilter,
  setSearchParameters: primaryPagingActions.setSearchParameters,
};

IngredientListingTable = connect(
  mapState,
  mapDispatch
)(withIngredientApi(IngredientListingTable, { refreshTotalPages: true }));

export { IngredientListingTable };



// WEBPACK FOOTER //
// ./src/pages/ingredientlisting/components/IngredientListingTable.js